import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import CusInput from '../../../../../components/material-ui/CusInput';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../store';
import { API_CASINO } from '../../../../../api/casino';
import useToast from '../../../../../hooks/useToast';
import SelectGroup from '../../../../../components/casino/SelectGroup';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import { dispatchCusEvent } from '../../../../../utils';
import { ENUM_CUS_EVENT } from '../../../../../enums/enums';

export default function NamesGroupContent() {
  const { casinoId } = useParams();
  const { t } = useTranslation();
  const { successToast } = useToast();

  const [casinoName, setCasinoName] = useState('');
  const [selectGroupId, setSelectGroupId] = useState('');

  useEffect(() => {
    API_CASINO.get
      .props({ casinoId: +casinoId, propsCasino: ['name', 'groupId'] })
      .then((e) => {
        const info = e.data.info;
        setCasinoName(info.name);
        setSelectGroupId(info.groupId);
      })
      .catch(console.error);
  }, [casinoId]);

  const onSaveClick = () => {
    API_CASINO.update({ casinoId: +casinoId, name: casinoName, groupId: selectGroupId })
      .then((e) => {
        dispatchCusEvent(ENUM_CUS_EVENT.getCasinos);
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <CusInput
            label={'Casino name'}
            maxLength={100}
            value={casinoName}
            onChange={(e) => setCasinoName(e.target.value)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <SelectGroup
            selectGroupId={selectGroupId}
            setSelectGroupId={setSelectGroupId}
            direction="column"
            isSelectNode={false}
          />
        </Grid>
      </Grid>

      <CasinoBtnSave sx={{ mt: 2 }} onClick={onSaveClick} />
    </>
  );
}
